import { api } from "@/_store/api-client";
import {
  GetIndicatorRiskParams,
  GetIndicatorRiskResponse,
  ICreateReportRequest,
  ICreateReportResponse,
  IGetReportRequest,
  IGetReportResponseWrapper
} from "./contracts";

export const companyApi = api.injectEndpoints({
  endpoints: (builder) => ({
    createReport: builder.mutation<ICreateReportResponse, ICreateReportRequest>({
      query: (requestBody) => ({
        url: "/api/v1/legal-reports/",
        method: "POST",
        body: requestBody,
      }),
      invalidatesTags: ["Report"],
    }),
    getReport: builder.query<IGetReportResponseWrapper, IGetReportRequest>({
      query: ({ id }) => ({
        url: `/api/v1/legal-reports/${id}/`,
        method: "GET",
      }),
      providesTags: ["ReportHistory", "Report"],
    }),
    getIndicatorRisk: builder.query<GetIndicatorRiskResponse, GetIndicatorRiskParams>({
      query: ({ inn }) => ({
        url: `/api/v1/indicator/?inn=${inn}`,
        method: "GET",
      }),
      providesTags: ["Risk"],
    })
  }),
  overrideExisting: false,
});

export const {
  useCreateReportMutation,
  useGetReportQuery,
  useGetIndicatorRiskQuery
} = companyApi;
